export const menuAnimations = {
  initial: { x: 50, opacity: 0 },
  animate: { x: 0, opacity: 1, transition: { duration: 0.1 } },
  exit: { x: 50, opacity: 0, transition: { duration: 0.1 } },
}
